import React, { Component } from "react";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import * as appConst from "../../../Common/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";

class Medicine extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mno: "",
      name: "",
      nameSuggestions: null,
      nameList: [],
      fromDate: "",
      toDate: ""
    };
  }

  componentDidMount() {
    this.LoadNames();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/medicine/getNames"
      )
      .then(response => {
        this.setState({ medList: response.data });
        let nameData = response.data;
        nameData.forEach(function(item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    return (
      <div>
        <h3 align="center">Medicine Tracker Report</h3>
        <div>
          <div className="container-fluid" />
          <div className="row p-1 border">
            <div className="col col-md-2">Medicine</div>
            <div className="col col-md-3">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={34}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">From Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.fromDate}
                onChange={e => this.setState({ fromDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
            <div className="col col-md-2">To Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.toDate}
                onChange={e => this.setState({ toDate: e })}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 12)}
                maxDate={new Date()}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
                width="300px"
              />
            </div>
          </div>

          <div className="row p-1 border">
            <button
              onClick={this.onGenerateClick}
              className="btn btn-primary btn-md mr-2"
            >
              Generate Report
            </button>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </div>
    );
  }

  onNameSelect = e => {
    let results = this.state.medList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    this.setState({ mno: results.mno });
  };

  onNameChange = e => {
    this.setState({
      name: e.value
    });
  };

  onGenerateClick = e => {
    e.preventDefault();

    if (
      this.state.mno === "" ||
      this.state.fromDate === "" ||
      this.state.toDate === ""
    ) {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input !!"
      });
    } else {
      let obj = {
        mno: this.state.mno,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate
      };

      this.props.onClick("Result", obj);
    }
  };
}

export default Medicine;
